<script setup lang="ts">
import { onMounted, provide } from 'vue';
import { useRoute } from 'vue-router';
import type { IToastsService } from '@a365/ui/services';
import { ToastService, EventLoggerService, type IEventLoggerService } from '@/services';
import { useAppConfigStore } from '@/stores/appConfigStore';

import BaseLayout from '@/layouts/BaseLayout.vue';

const route = useRoute();
const toastsService: IToastsService = new ToastService();
const eventLogger: IEventLoggerService = new EventLoggerService(() => route.params['workspaceId'] as string);
const appConfigStore = useAppConfigStore();

provide('toastsService', toastsService);
provide('eventLogger', eventLogger);

onMounted(() => {
  appConfigStore.refreshConfig();
});
</script>

<template>
  <BaseLayout />
</template>
